import React from 'react';
import classnames from 'classnames';

import BreakpointButton from './breakpoint-button';

import styles from './breakpoint-controls.scss';

export default class BreakpointControls extends React.Component {
  constructor() {
    super();

    this.state = {autoEnabledBreakpoint: null};

    this.handleNotificationDismiss = this.handleNotificationDismiss.bind(this);
  }

  handleBreakpointChange(breakpointName) {
    return () => {
      if (breakpointName !== this.props.activeBreakpoint) {
        this.props.onChangeBreakpoint(breakpointName);
      }
    };
  }

  handleEnabledChange(breakpointName) {
    return (enabled) => {
      const {breakpointsEnabled, onChangeBreakpointEnabled} = this.props;
      const otherBreakpoint = breakpointName === 'desktop' ? 'mobile' : 'desktop';

      onChangeBreakpointEnabled(breakpointName, enabled);

      if (!enabled && !breakpointsEnabled[otherBreakpoint]) {
        onChangeBreakpointEnabled(otherBreakpoint, true);
        this.setState({autoEnabledBreakpoint: otherBreakpoint});
      } else {
        this.setState({autoEnabledBreakpoint: null});
      }
    };
  }

  handleNotificationDismiss() {
    this.setState({autoEnabledBreakpoint: null});
  }

  render() {
    if (!this.props.visible) {
      return null;
    }

    const {activeBreakpoint, togglingAllowed, breakpointsEnabled} = this.props;
    const {autoEnabledBreakpoint} = this.state;

    return (
      <div className='responsive-device-container'>
        {
          ['desktop', 'mobile'].map((breakpointName) => {
            return (
              <BreakpointButton
                key={breakpointName}
                breakpointName={breakpointName}
                breakpointEnabled={breakpointsEnabled[breakpointName]}
                breakpointActive={activeBreakpoint === breakpointName}
                showToggle={togglingAllowed[breakpointName]}
                showNotification={autoEnabledBreakpoint === breakpointName}
                onClick={this.handleBreakpointChange(breakpointName)}
                onToggle={this.handleEnabledChange(breakpointName)}
                onNotificationDismiss={this.handleNotificationDismiss}
              />
            );
          })
        }

        {togglingAllowed.mobile &&
          <a className={classnames('help-button tip-mobile', styles.helpButton)} />
        }
      </div>
    );
  }
}

BreakpointControls.propTypes = {
  activeBreakpoint: React.PropTypes.oneOf(['desktop', 'mobile']).isRequired,
  togglingAllowed: React.PropTypes.shape({
    desktop: React.PropTypes.bool.isRequired,
    mobile: React.PropTypes.bool.isRequired,
  }).isRequired,
  breakpointsEnabled: React.PropTypes.shape({
    desktop: React.PropTypes.bool.isRequired,
    mobile: React.PropTypes.bool.isRequired,
  }).isRequired,
  visible: React.PropTypes.bool.isRequired,
  onChangeBreakpoint: React.PropTypes.func.isRequired,
  onChangeBreakpointEnabled: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/components/breakpoint-controls.jsx